import request from '@/utils/request'

const call = (domain, path, method, data) => request({
  url: `/api/app/${domain}/${path}`,
  method,
  ...(method === 'get' || method === 'delete' ? { params: data } : { data })
})
const crud = (domain, name) => ({
  list: params => call(domain, `${name}-list`, 'get', params),
  create: data => call(domain, `create-${name}`, 'post', data),
  update: (id, data) => call(domain, `update-${name}/${encodeURIComponent(id)}`, 'put', data),
  remove: id => call(domain, `delete-${name}/${encodeURIComponent(id)}`, 'delete')
})
const download = (domain, path, params) => request({
  url: `/api/app/${domain}/${path}`, method: 'get', params, responseType: 'blob'
})
const upload = (domain, path, file) => {
  const data = new FormData()
  data.append('File', file)
  return call(domain, path, 'post', data)
}

export const controlApi = {
  ...crud('vehicle-control', 'control'),
  import: file => upload('vehicle-control', 'import-control-data', file),
  export: params => download('vehicle-control', 'export-control-data', params)
}
export const chassisApi = {
  ...crud('vehicle-chassis', 'chassis'),
  import: file => upload('vehicle-chassis', 'import-chassis-data', file),
  export: params => download('vehicle-chassis', 'export-chassis', params)
}
export const policyApi = {
  ...crud('vehicle-insurance', 'policy'),
  detail: id => call('vehicle-insurance', `policy/${encodeURIComponent(id)}`, 'get'),
  import: file => upload('vehicle-insurance', 'import-insurance-data', file),
  export: params => download('vehicle-insurance', 'export-policies', params)
}
export const bindingApi = {
  ...crud('vehicle-insurance', 'binding'),
  end: (id, endDate) => call('vehicle-insurance', `end-binding/${encodeURIComponent(id)}`, 'put', { endDate }),
  import: file => upload('vehicle-insurance', 'import-bindings', file),
  export: params => download('vehicle-insurance', 'export-chassis-insurances', params)
}
// 保险预警（GET /api/app/vehicle-insurance/warning，无参数，前端筛选）
export const insuranceWarningApi = {
  warning: params => call('vehicle-insurance', 'warning', 'get', params)
}
export const vehicleDataApi = {
  insurancePage: params => call('vehicle-data', 'vehicle-insurance-page', 'get', params),
  insuranceByPeriod: params => call('vehicle-data', 'vehicle-insurance-by-period', 'get', params),
  page: params => call('vehicle-data', 'vehicle-data-page', 'get', params),
  detail: id => call('vehicle-data', 'vehicle-data-detail', 'get', { id }),
  logs: params => call('vehicle-data', 'change-logs', 'get', params),
  logChain: params => call('vehicle-data', 'log-chain', 'get', params),
  logChainExpand: params => call('vehicle-data', 'log-chain/expand', 'get', params),
  logChainDetail: params => call('vehicle-data', 'log-chain/detail', 'get', params),
  export: params => call('vehicle-data', 'export-operation-list', 'get', params)
}

export const assetPermission = name => `DataAnalysis.VehicleAnalysis.${name}`
